import React, { useEffect, Fragment, useState } from "react";
import FormValidators from "../FormValidators/index";
import NonHostedLinks from "./NonHostedLinks";
import { Field, reduxForm } from "redux-form";
import { UpwardReduxInput } from "../ui";
import axios from "axios";

const EmailForm = (props) => {
  const [count, setCount] = useState(0);
  const [displayQuestions, setDisplayQuestions] = useState(false);

  const flowVal = props.sessionId % 2 === 0 ? 1 : 0;

  useEffect(() => {
    props.updatePhone(formatPhoneChange(props.phone));
    if(count === 1){
      document.getElementById("fname").focus();
      document.getElementById("lname").focus();
      document.getElementById("email").focus();
      document.getElementById("phone").focus();
      setCount(count + 1);
    }
  },[]);

  function setFocus(){
    setDisplayQuestions(true);
    if(count === 0){
      document.getElementById("fname").select();
      document.getElementById("lname").select();
      document.getElementById("phone").select();
      document.getElementById("email").select();
      document.getElementById("email").focus();
      document.getElementById("fname").focus();
      document.getElementById("lname").focus();
      document.getElementById("phone").focus();

      setCount(count + 1);
    }
  }

  function setFocus2(){
    document.getElementById("fname").focus();
    document.getElementById("lname").focus();
    document.getElementById("phone").focus();
    document.getElementById("email").focus();
  }

  let headersConfig = {
    headers : {
      "X-Requested-With" : "XMLHttpRequest",
      "Cache-Control" : "no-cache"
    }
  }

  function formatPhoneChange(input){
    input = input.replace(/\D/g,'');

    input = input.substring(0,10);

    var size = input.length;
    if(size === 0){
      input = input;
    }else if(size < 4){
      input = '('+input;
    }else if(size < 7){
      input = '('+input.substring(0,3)+')'+input.substring(3,6);
    }else{
      input = '('+input.substring(0,3)+')'+input.substring(3,6)+'-'+input.substring(6,10);
    }
    return input;
  }

  function formatNum(e) {
    props.updatePhone(formatPhoneChange(e.target.value))
  }

  let resumeCB = document.getElementsByClassName('resumeOptinRadio');
    let optinsQuery;
    if(resumeCB.length > 0){
        let confirmations = resumeCB.checked.map(function(i,item){ return item.value}).get().filter(function(item){ return item = "" }).join(",");
        optinsQuery = {
            optin_advertisers : confirmations,
            _ : + new Date()
        }
    } else {
      optinsQuery = {
        regOid : 3944,
        optin_advertisers : props.coRegAdvertisers,
        _ : + new Date()
      }
    }

  const optinsQueryString = Object.keys(optinsQuery).map(key => key + '=' + optinsQuery[key]).join('&');

  const handleSubmit = e => {

    //window.dataLayer.push({'uwCID': props.cid ? props.cid : ''});

    props.showLoad();

    axios.all([
      axios.get(process.env['REACT_APP_API_URL'] + '/upward/accountSignup.jsp?noeml=true&OID=3002&' + props.queryString),
      axios.get(process.env['REACT_APP_API_URL'] + '/search/internalPost2.fsn?OID=3002&new_flow=' + flowVal +"&" + props.queryString),
    ])
    .then(data => {
      window.newrelic.addPageAction('registration', {registration: 'success', file: 'EmailFormHosted.js'});
      props.setLoggedIn(true);
      if(props.termsText !== ""){
        window.getAvailableOptins();
        axios.get(process.env['REACT_APP_API_URL'] + "/upward/resumeOptins2.jsp?" + optinsQueryString);
      }
      axios.post(process.env['REACT_APP_API_URL'] + "/upward/applicationSubmit.jsp", props.queryString3, headersConfig);
      if (props.queryString2.includes('phone')) {
        axios.get(process.env['REACT_APP_API_URL'] + "/upward/smsActions.jsp?OID=2984&" + props.queryString2);
      }
      props.updateEmail(props.email);
      if(props.hasResume &&props.hasResume === "T"){
        props.onFormSubmit('customForm');
      }else{
        props.onFormSubmit('uploadResume');
      }
      props.hideLoad();
    }, (error) => {
      window.newrelic.addPageAction('registration', {registration: 'failure', file: 'EmailFormHosted.js'});
      window.Rollbar.error("hosted email form error", error);
      if(props.hasResume && props.hasResume === "T"){
        props.onFormSubmit('customForm');
      }else{
        props.onFormSubmit('uploadResume');
      }
      props.hideLoad();
    });

  }

    return (
        <Fragment>
            <form onSubmit={props.handleSubmit(handleSubmit)} autoComplete="off">
                <div className="form-group">
                   <Field component={UpwardReduxInput}
                      validate={[FormValidators.required,FormValidators.email]}
                      type="email"
                      name="email"
                      id="email"
                      controlledValue={props.email}
                      placeholder="name@domain.com"
                      onChange={e => props.updateEmail(e.target.value)}
                      onClick={() => setFocus()}/><br />
                   <div style={displayQuestions && !props.loading ? {} : {opacity: '0', height: '0px', position: 'absolute', top: '-500px'}}>
                     <Field component={UpwardReduxInput}
                        validate={[FormValidators.required, FormValidators.nameNoSpecialChars]}
                        type="text" name="fname"
                        id="fname" placeholder="First name"
                        controlledValue={props.fname}
                        onChange={e => props.updateFName(e.target.value.trim().split(/ +/).join(' '))}
                        /><br />
                      <Field component={UpwardReduxInput}
                        type="text" name="lname"
                        validate={[FormValidators.required, FormValidators.nameNoSpecialChars]}
                        id="lname" placeholder="Last name"
                        controlledValue={props.lname}
                        onChange={e => props.updateLName(e.target.value.trim().split(/ +/).join(' '))}/><br />
                     <Field component={UpwardReduxInput}
                        validate={[FormValidators.required, FormValidators.phoneNumberLength]}
                        type="text"
                        name="phone"
                        id="phone"
                        controlledValue={props.phone}
                        placeholder="(xxx) xxx - xxxx"
                        onChange={e => formatNum(e)}/>
                    </div>
                    <div className={"loading " + ( props.loading ? 'in' : '')}><div className="spinner"><div className="bounce1"></div><div className="bounce2"></div><div className="bounce3"></div></div></div>
                    <div className="text-center"><button type="submit" className="btn btnSmall fullwidth btn-block" onClick={() => {setFocus();setFocus2()}}>Continue</button></div>
                </div>
                {(((props.hostedType.toLowerCase() !== "hosted" && props.hostedType.toLowerCase() !== "hosted_plus") ||  (props.hostedType.toLowerCase() === "")) && (window.skipVal === "yes" || window.skipVal === "x"))
                &&
                <NonHostedLinks {...props}/>
                }
            </form>
        </Fragment>
    )

}

export default reduxForm({
  form: 'EmailForm',
})(EmailForm);
